export default __webpack_public_path__ + "static/media/trip_hop.5fbd08ca.png";